namespace Portico.Services {

    import ent = Portico.Models.Enterprise;
    import psga = apigateway.client;
    import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IProgramService {
        //get: () => angular.IPromise<ent.Program[]>;
        //getByCode: (code: string) => angular.IPromise<ent.Program>;
        //getByTenantId: (tenantId: number) => angular.IPromise<ent.Program[]>;
    }

    @Service('app', 'programService')
    @Inject('$q', 'apiService', 'ProgramV2Api')
    export class ProgramService implements IProgramService {
        constructor(
            private $q: angular.IQService,
            private apiService: IApiService,
            private programV2Api: psga.ProgramV2Api
        ) { }

        //get(): angular.IPromise<ent.Program[]> {
        //    return this.programV2Api.getByTenantId(null, null, null).then((response) => {
        //        const programs: ent.Program[] = [];

        //        for (const program of response) {
        //            programs.push(new ent.Program(program));
        //        }

        //        return programs;
        //    });
        //}

        //getByCode(code: string): angular.IPromise<ent.Program> {
        //    return this.programV2Api.getByTenantId(code, null, null).then((response) => {
        //        return new ent.Program(response[0]);
        //    });
        //}

        //getByTenantId(tenantId: number): angular.IPromise<ent.Program[]> {
        //    return this.programV2Api.getByTenantId(null, null, null).then((response) => {
        //        const programs: ent.Program[] = [];

        //        for (const program of response) {
        //            programs.push(new ent.Program(program));
        //        }

        //        return programs;
        //    });
        //}
    }
}